module.exports = __webpack_public_path__ + "img/sketch.1fe627a7.png";